import React, { useContext } from "react";

import Section from "../components/common/Section";
import { Card, Col, Row } from "react-bootstrap";
import Logo from "../components/common/Logo";
import Flex from "../components/common/Flex";
import { Navigate, Outlet } from "react-router-dom";
import { AppContext } from "../context/AppContext";
import PATH from "../routes/RoutePath";

const AuthLayout: React.FC = () => {
  const { user } = useContext(AppContext);
  if (user.isUserLoggedIn) {
    return <Navigate to={"/" + PATH.USERS.USERS_LIST} />;
  }

  return (
    <Section className="py-0">
      <Row className="flex-center min-vh-100 py-6">
        <Col sm={10} md={8} lg={6} xl={5} className="col-xxl-4 ">
          <Flex justifyContent="center" alignItems="center" className="mb-4">
            <Logo width={200} />
          </Flex>
          <Card>
            <Card.Body className="p-4 p-sm-5">
              <Outlet />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Section>
  );
};

export default AuthLayout;
